import { Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject, Subscription, fromEvent, merge, takeUntil, timer } from 'rxjs';
import { IdleDialogComponent } from '../feature/idle-dialog/idle-dialog.component';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  rxjsTimer: Observable<number>;  // Declare as Observable
  timer: number;
  destroy = new Subject<void>();  // Use void for clarity
  private timerSubscription: Subscription;
  private idle$: Observable<Event>; 
  private isLoggedIn: boolean = true;
  private popupStatus: boolean = true;
  idleMinutes: number = (5*60);

  constructor(
    private ngZone: NgZone, 
    private dialog: MatDialog, 
    private router: Router, 
    private authService: AuthService
  ) { 
    this.rxjsTimer = timer(1000, 1000);

    this.authService.getLoginStatus().subscribe(status => {
      this.isLoggedIn = status;
      // this.isLoggedIn = true;
      console.log("llll",this.isLoggedIn)
      // this.downloadInvoice();

      if(this.isLoggedIn){
        this.destroy.next(); 
      this.startTimer(); 
        this.setupIdleDetection(); // Setup event listeners outside Angular zone
        // this.resetTimer(); 
        }
    });

    this.ngZone.runOutsideAngular(() => {

      if(this.isLoggedIn){
      this.destroy.next(); 
    this.startTimer(); 
      this.setupIdleDetection(); // Setup event listeners outside Angular zone
      // this.resetTimer(); 
      }
    });

  }


    // Method to reset the timer
    private resetTimer(): void {
      this.timer = 0; 
      this.timerSubscription.unsubscribe();  // Unsubscribe from the current timer
      this.rxjsTimer = timer(1000, 1000);  // Create a new timer
      this.startTimer();  // Restart the subscription
    }
  public setupIdleDetection() {
    // this.destroy.next(); 
    // this.startTimer(); 
    // this.timer = 0; 
    // this.rxjsTimer = timer(1000, 1000);
    
    // Merge multiple user activity events into a single observable
    this.idle$ = merge(
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'click'),
      fromEvent(window, 'keydown'),
      fromEvent(window, 'scroll')
    );
    if(this.isLoggedIn){
    // Subscribe to user activity events
    this.idle$.subscribe(() => {
      // this.userActivity.next(); // Emit user activity
      if(this.popupStatus){
      this.destroy.next(); 
      this.startTimer();
      // console.log('User activity detected, resetting timer.');
      }
    });
    
  }
  }
  private startTimer(): void {
    this.popupStatus = true;
    // Subscribe to the timer
    this.timerSubscription = this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe(val => {
      this.timer = val;
      // console.log("time::", this.timer);
      if (this.timer === this.idleMinutes) {
        // alert(1);
        // this.resetTimer();  // Reset when timer reaches 10
        this.destroy.next(); 
        this.popupStatus = false;
        this.openIdleDialog()
      }
    });
  }

  idleDestroy() {
    this.destroy.next(); 
    this.destroy.complete(); 
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();  // Unsubscribe on component destroy
    }
  }

  openIdleDialog() {
    
    const dialogRef = this.dialog.open(IdleDialogComponent,{
      width: '25%',
      disableClose: true,
      data: { title: "Idle Timeout", caption: ``, message: `You will time out in ${this.timer} seconds!`, close_btn: 'Stay', submit_btn: 'Logout', submit_btn_clicked: false }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("result", result)
      if (result.stay) {
        // User chose "No", you can log them out or take other actions.
        console.log('User chose No, take some action.');
        this.destroy.next(); 
      this.startTimer();
      } else {
        // Reset idle timer
        console.log('User chose Yes, resetting the idle timer.');
        this.idleDestroy();
        this.router.navigate(['/']);
      }
    });
  }
}
